import React from "react";
import "../styles/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="po">
      <div className="po1">
        <h2 className="pph2 fsh2 m1">Privacy Policy</h2>
        <p className="ppp">Effective Date: 22/09/2025</p>
      </div>

      <div className="po2">
        <div>
          <p>
            Welcome to Mpeoples.in mobile application (“App”). We are committed
            to protecting your privacy and providing a safe and transparent user
            experience. This Privacy Policy explains how we collect, use, share,
            and protect your information when you use our App, website, or
            related services.
          </p>
        </div>

        <div>
          <h2>Information We Collect</h2>

          <p>
            <strong>Personal Information:</strong> When you interact with our App,
            we may collect personal information such as your name, email address,
            and other details you provide voluntarily.
          </p>

          <p>
            <strong>Usage Data:</strong> We automatically collect data about how
            you use the App, including your device type, operating system, IP
            address, pages or screens visited, and app interactions.
          </p>

          <p>
            <strong>Device Identifiers:</strong> To serve personalized or
            non-personalized ads and improve services, we may collect unique
            device identifiers such as Advertising ID or IDFA.
          </p>

          <p>
            <strong>Cookies and Tracking Technologies:</strong> We may use
            cookies, local storage, or similar technologies to analyze usage and
            improve user experience. Third-party services such as Google AdMob
            may also use cookies or trackers.
          </p>

          <p>
            <strong>Reminder and Alarm Data:</strong> Our App allows users to set
            reminders and alarms. Reminder details such as title, date, and time
            are used only to trigger alerts and notifications. This data is
            stored locally on your device or securely on our servers and is not
            shared with advertisers.
          </p>

          <p>
            <strong>API Data:</strong> Our App may fetch data from third-party
            services (such as fuel price APIs) to display relevant information.
          </p>
        </div>

        <div>
          <h2>How We Use Your Information</h2>

          <p>
            <strong>To Provide and Improve Services:</strong> We use your
            information to operate app features, show content, improve
            performance, and enhance user experience.
          </p>

          <p>
            <strong>To Provide Reminder and Alarm Services:</strong> Reminder and
            alarm data is used only to schedule and trigger notifications
            requested by you.
          </p>

          <p>
            <strong>To Serve Ads:</strong> We display ads including native ads
            using Google AdMob. Ad personalization depends on your device and
            Google account settings.
          </p>

          <p>
            <strong>To Communicate:</strong> We may send important updates,
            service notifications, or alerts related to reminders and alarms.
          </p>

          <p>
            <strong>For Analytics:</strong> We analyze usage data to understand
            feature usage and improve app stability.
          </p>
        </div>

        <div>
          <h2>Advertising and AdMob</h2>
          <p>
            Our App uses Google AdMob to display banner, interstitial, and native
            advertisements. AdMob may collect device identifiers, cookies, and
            usage data to serve personalized or non-personalized ads in
            accordance with Google’s Privacy Policy.
          </p>
          <p>
            We do not have control over how Google collects or uses data. Users
            can manage ad preferences through their Google account or device
            settings.
          </p>
        </div>

        <div>
          <h2>How We Share Your Information</h2>

          <p>
            <strong>With Service Providers:</strong> We may share limited data
            with trusted service providers such as hosting, analytics, and
            advertising partners to operate the App.
          </p>

          <p>
            <strong>For Legal Reasons:</strong> We may disclose information if
            required by law or to protect users and our legal rights.
          </p>

          <p>
            <strong>Business Transfers:</strong> In the event of a merger,
            acquisition, or sale, user information may be transferred as part
            of business assets.
          </p>
        </div>

        <div>
          <h2>App Permissions</h2>
          <p>
            Our App may request permissions such as notifications, alarms, or
            exact scheduling in order to provide reminder and alert features.
            These permissions are used strictly for intended functionality.
          </p>
        </div>

        <div>
          <h2>How We Protect Your Information</h2>
          <p>
            We use reasonable administrative and technical safeguards to protect
            your information. However, no method of data transmission or storage
            is 100% secure.
          </p>
        </div>

        <div>
          <h2>Your Choices</h2>

          <p>
            <strong>Access and Update:</strong> You may request access to or
            correction of your personal information.
          </p>

          <p>
            <strong>Ad Personalization:</strong> You can control personalized ads
            through your device settings or Google Ads settings.
          </p>

          <p>
            <strong>Notifications:</strong> You may disable notifications and
            alarms at any time through your device settings.
          </p>

          <p>
            <strong>Cookies:</strong> Cookie preferences can be managed in your
            browser or device.
          </p>
        </div>

        <div>
          <h2>Children’s Privacy</h2>
          <p>
            Our App is not intended for children under the age of 13. We do not
            knowingly collect personal data from children.
          </p>
        </div>

        <div>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be
            posted within the App or on our website.
          </p>
        </div>

        {/* 🔴 DISCLAIMER SECTION ADDED */}
        <div>
          <h2>Disclaimer</h2>
          <p>
            The information and articles provided in this App are for general
            informational and awareness purposes only. This content is not
            intended as medical, professional, or legal advice. Users are
            advised to consult a qualified professional for specific concerns.
          </p>
        </div>

        {/* 🔴 TAMIL + ENGLISH DISCLAIMER */}
        <div>
          <h2>அறிவிப்பு (Disclaimer – Tamil)</h2>
          <p>
            இந்த செயலியில் வழங்கப்படும் தகவல்கள் மற்றும் கட்டுரைகள் பொதுவான
            அறிவு மற்றும் விழிப்புணர்வு நோக்கத்திற்காக மட்டுமே. இவை மருத்துவ,
            சட்ட அல்லது தொழில்முறை ஆலோசனையாக கருதப்படக் கூடாது. குறிப்பிட்ட
            தேவைகளுக்கு தகுதியான நிபுணரை அணுகவும்.
          </p>
        </div>

        {/* 🔴 CONTENT & HEALTH DISCLAIMER */}
        <div>
          <h2>Content & Health Information Disclaimer</h2>
          <p>
            The articles, informational facts, calendar content, and posters
            provided in this App are for general informational and awareness
            purposes only.
          </p>

          <p>
            Any health-related content is not intended to be medical advice,
            diagnosis, or treatment. Users should always consult a qualified
            medical or professional expert.
          </p>

          <p>
            The App does not guarantee the accuracy, completeness, or reliability
            of the content and shall not be held responsible for decisions made
            based on such information.
          </p>
        </div>

        <div>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us:
          </p>

          <p>Mpeoples Business Solution Private Limited</p>

          <p>
            1/248, Raja Ganapathy Complex, <br />
            2nd Floor, Opposite BSNL Office, Meyyanur Main Road, <br />
            Salem – 636004.
          </p>

          <p>Email: mpeoplesofficial@gmail.com</p>
          <p>Phone: 9487812715</p>

          <p>Thank you for trusting Mpeoples.in.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
